import { getElementByProjectElementIdApi } from '@core/core/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import type { PolygonId, ProjectId } from 'common/types'

import { deleteElementToTrashForce } from '../signalR'

export const deletePolygonFromProject = createAsyncThunk<
  Promise<void>,
  {
    projectId: ProjectId
    polygonId: PolygonId
  }
>('polygons/deleteFromProject', async ({ projectId, polygonId }, { dispatch }) => {
  const entity = await getElementByProjectElementIdApi(projectId, polygonId, 'polygon')
  dispatch(deleteElementToTrashForce(entity.uid))
})
